/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import { UploadsUrl } from '../../services/url'
const Link_Box1 = (props) => {
  return (
    <div
      className='d-flex justify-content-end'
      onClick={() => localStorage.setItem('consultingId', props.data._id)}
    >
      <a href={props.link} className='link-box-1'>
        <div className='avatar'>
          <img
            src={`${UploadsUrl}/${props.data.lawyer.avatar}`}
            alut='default-user'
          />
        </div>
        <div className='detail'>
          <h4>{`${props.data.lawyer.fname} ${props.data.lawyer.lname}`}</h4>
          <p>{props.job}</p>
          <div>
            <div className='tag'>
              <span>{props.data.consultingService.service.title}</span>
            </div>

            {/* <div>
              <p>{props.data.consultingService.type}</p>
            </div> */}
          </div>
        </div>
      </a>
    </div>
  )
}
export default Link_Box1
